export { default as TablePagination } from './TablePagination';
